import i18n, {ReadCallback} from 'i18next';
import {initReactI18next} from 'react-i18next';
import {supportedLocales} from '@webng-types/i18n';

import liveblogEn from '@webng/i18n-common/src/translations/liveblog.json'
import liveblogDe from '@webng/i18n-common/src/translations/liveblog.de.json'
import liveblogEnGb from '@webng/i18n-common/src/translations/liveblog.en-GB.json'
import liveblogZhTw from '@webng/i18n-common/src/translations/liveblog.zh-TW.json'
import liveblogFr from '@webng/i18n-common/src/translations/liveblog.fr.json'
import liveblogFrFr from '@webng/i18n-common/src/translations/liveblog.fr-FR.json'
import liveblogFrCa from '@webng/i18n-common/src/translations/liveblog.fr-CA.json'
import liveblogItIt from '@webng/i18n-common/src/translations/liveblog.it-IT.json'
import liveblogNlNl from '@webng/i18n-common/src/translations/liveblog.nl-NL.json'
import liveblogPt from '@webng/i18n-common/src/translations/liveblog.pt.json'
import liveblogPl from '@webng/i18n-common/src/translations/liveblog.pl.json'
import liveblogRu from '@webng/i18n-common/src/translations/liveblog.ru.json'
import liveblogLt from '@webng/i18n-common/src/translations/liveblog.lt.json'
import liveblogEt from '@webng/i18n-common/src/translations/liveblog.et.json'
import liveblogElGr from '@webng/i18n-common/src/translations/liveblog.el-GR.json'
import liveblogAf from '@webng/i18n-common/src/translations/liveblog.af.json'
import liveblogFi from '@webng/i18n-common/src/translations/liveblog.fi.json'
import {findClosestLanguage} from '@webng/i18n-common';

export function detectHtmlLanguage(): string {
  if(document.documentElement.lang) {
    return findClosestLanguage(document.documentElement.lang);
  } else {
    return findClosestLanguage(navigator.language);
  }
}

// const languageDetector: LanguageDetectorModule = {
//   type: 'languageDetector',
//   init: function(services, detectorOptions, i18nextOptions) {
//     /* use services and options */
//   },
//   detect:detectHtmlLanguage,
//   cacheUserLanguage: function(lng) {}
// }

function i18nFileName(name: string, language: string) {
  if(language === 'en') {
    return `${name}.json`;
  } else {
    const languageParts = language.split("-");
    if (languageParts.length > 1){
      languageParts[languageParts.length -1] = languageParts[languageParts.length -1].toUpperCase();
    }
    return `${name}.${languageParts.join("-")}.json`;
  }
}

i18n
  // .use(languageDetector)
  .use(initReactI18next)
  .use({
    type: 'backend',
    read(
      language: string,
      namespace: string,
      callback: ReadCallback
    ) {
      if(namespace === 'sports') {
        if(language === 'en') {
          import(/* webpackChunkName: "i18n-sports-en" */`@webng/sports/i18n/sports.json`).then(mod => callback(null, mod))
        } else {
          import(/* webpackChunkName: "i18n-[request]" */ `@webng/sports/i18n/${i18nFileName("sports", language)}`).then(mod => callback(null, mod))
        }

      } else {
        callback(new Error(`can not dynamically load ${namespace} for en/de`), null)
      }
    }
  })
  .init({
    resources: {
      en: {liveblog: liveblogEn},
      de: {liveblog: liveblogDe},
      'en-gb': {liveblog: liveblogEnGb},
      'en-ie': {liveblog: liveblogEnGb},
      'en-au': {liveblog: liveblogEnGb},
      'en-nz': {liveblog: liveblogEnGb},
      'zh-tw': {liveblog: liveblogZhTw},
      fr: {liveblog: liveblogFr},
      'fr-fr': {liveblog: liveblogFrFr},
      'fr-ca': {liveblog: liveblogFrCa},
      'it-it': {liveblog: liveblogItIt},
      'nl-nl': {liveblog: liveblogNlNl},
      pt: {liveblog: liveblogPt},
      pl: {liveblog: liveblogPl},
      ru: {liveblog: liveblogRu},
      lt: {liveblog: liveblogLt},
      et: {liveblog: liveblogEt},
      'el-gr': {liveblog: liveblogElGr},
      af: {liveblog: liveblogAf},
      fi: {liveblog: liveblogFi}
    },
    lowerCaseLng: true,
    lng: 'en',
    fallbackLng: {
      'fr-fr': ['fr', 'en'],
      'fr-ca': ['fr', 'en'],
      default: ['en']
    },
    supportedLngs: [...supportedLocales],
    detection: {},
    interpolation: {
      escapeValue: false
    },
    defaultNS: "liveblog",
    ns: ["liveblog"],
    debug: window.location.href.includes("localhost"),
    load: 'currentOnly'
  })

export default i18n
